/**
 * Retorna a data atual no formato iso date string
 * @returns year-month-day
 */
export function getDataAtualNoFormatoIsoDateString() {
  const [dia, mes, ano] = new Date().toLocaleDateString('pt-br').split('/')

  const pad = num => num.toString().padStart(2, '0')

  const isoDate = `${ano}-${pad(mes)}-${pad(dia)}`

  return isoDate
}

/**
 * Retorna a data atual no formato locale date string
 * @returns day/month/year
 */
export function getDataAtualNoFormatoLocaleDateString() {
  return new Date().toLocaleDateString('pt-br')
}

/**
 * Retorna o dateTime atual no formato iso dateTime string
 * @returns day-month-yearThours:minutes:seconds
 */
export function getDateTimeAtualNoFormatoIsoDateTimeString() {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * Retorna o horário atual no formato locale time string
 * @returns hours:minutes
 */
export function getHorarioLocalAtualComApenasHorasEMinutos() {
  return new Date().toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
}

/**
 * Retorna o horário recebido com apenas hora e minutos
 * @returns hours:minutes
 */
export function getTimeStringComApenasHorasEMinutos(timeString) {
  if (!timeString) return null

  return timeString.split(':').filter((_, index) => index < 2).join(':')
}

/**
 * Converte uma date string para o formato locale date string
 * @param {string} dateString
 * @returns day/month/year
 */
export function converterDateStringEmLocaleDateString(dateString) {
  if (!dateString) return null
  return new Date(dateString).toLocaleDateString('pt-br')
}

/**
 * Converte um dateTime para o formato locale dateTime string
 * @param {string} dateTimeString
 * @returns day/month/year - hours:minutes:seconds
 */
export function converterDateTimeStringEmLocaleDateTimeString(dateTimeString) {
  if (!dateTimeString) return null

  const localeDate = new Date(dateTimeString).toLocaleDateString('pt-BR')
  const localeTime = new Date(dateTimeString).toLocaleTimeString('pt-BR')

  return `${localeDate} - ${localeTime}`
}

/**
 * Converte uma locale date string para o formato iso date string
 * @param {string} dataLocal
 * @returns {string} 'year-month-day'
 */
export function converterLocaleDateStringParaOFormatoIsoDateString(localeDateString) {
  if (!localeDateString) return null

  const [dia, mes, ano] = localeDateString.split('/')

  const pad = num => num.toString().padStart(2, '0')

  const isoDate = `${ano}-${pad(mes)}-${pad(dia)}`

  return isoDate
}

/**
 * Retorna a data inicial do mês atual
 * @returns {string} 'year-month-day'
 */
export function getDataInicialMes() {
  const date = new Date()
  return converterLocaleDateStringParaOFormatoIsoDateString(new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('pt-br'))
}

/**
 * Retorna a data final do mês
 * @returns {string} 'year-month-day'
 */
export function getDataFinalMes() {
  const date = new Date()
  return converterLocaleDateStringParaOFormatoIsoDateString(new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('pt-br'))
}

/**
 * Converte um dateTime para o formato iso dateTime string
 * @param {string} dateTimeString
 * @returns {string} 'year-month-dayThours:minutes:seconds'
 */
export function converterDateTimeParaOFormatoIsoDateTimeString(dateTime) {
  if (!dateTime) return null

  const pad = num => String(num).padStart(2, '0')

  const year = dateTime.getFullYear()
  const month = pad(dateTime.getMonth() + 1)
  const day = pad(dateTime.getDate())
  const hours = pad(dateTime.getHours())
  const minutes = pad(dateTime.getMinutes())
  const seconds = pad(dateTime.getSeconds())

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * Converte uma dateTime string para o formato iso dateTime string
 * @param {string} dateTimeString
 * @returns {string} 'year-month-dayThours:minutes:seconds'
 */
export function converterDateTimeStringParaOFormatoIsoDateTimeString(dateTimeString) {
  if (!dateTimeString) return null

  const date = new Date(dateTimeString)

  const pad = num => String(num).padStart(2, '0')

  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * Concatena uma iso date string e um time string em uma iso dateTime string
 * @param {string} isoDateString
 * @param {string} timeString
 * @returns
 */
export function concatenarIsoDateStringETimeStringEmIsoDateTimeString(isoDateString, timeString) {
  const [year, month, day] = isoDateString.split('-').map(Number)
  const [hours, minutes] = timeString.split(':').map(Number)

  const pad = num => num.toString().padStart(2, '0')

  const dateTimeIso = `${year}-${pad(month)}-${pad(day)}T${pad(hours)}:${pad(minutes)}:00.000Z`

  return dateTimeIso
}
